import TableHeader from '../Header';
import TableWrapper from '../Wrapper';
import { TableProvider } from '../context';
import { PinnedColumnsProvider } from '../pinned'

import TableBody from './Body'

export default function Table() {
  return <TableProvider>
    <PinnedColumnsProvider>
      <TableWrapper>
        <TableHeader />
        <TableBody />
      </TableWrapper>
    </PinnedColumnsProvider>
  </TableProvider>
}
